import Commons from '../../../Services/Common/Common';

export const M_PEA_BASIC_Schema = {
  mapper: {
    search1: {
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
